// export const deletePlusStart = (string) => {
//     let stringClear = string
//     if (string.charAt(0) === '+') {
//         const split = string.split('')
//         split.shift()
//         stringClear = split.join('')
//     }
//     return stringClear
// }

// export const randomString = (len) => { // формирование рандомной строки
//     const chrs = 'abdehkmnpswxzABDEFGHKMNPQRSTWXZ123456789';
//     const lengthTemp = len ? len : 5
//     let str = '';
//     for (var i = 0; i < lengthTemp; i++) {
//         var pos = Math.floor(Math.random() * chrs.length);
//         str += chrs.substring(pos, pos + 1);
//     }
//     return str;
// }

export const numberValidate = (str) => { // Проверка на только числа в строке
    // console.log('str', str)
    const reg = /^\d+$/
    const validate = reg.test(str)
    // console.log('validate', validate)
    return validate
}

export const numberFullValidate = (str) => { // Проверка на только числа в строке (+ .)
    // const reg = /^[+-]?\d+(?:[.,]\d+)?$/
    const reg = /^[-]?\d+(?:[.,]\d+)?$/
    const validate = reg.test(str)
    return validate
}

export const stringLength = ({ string, maxLength = 20, isDots }) => {
    try {
        let stringShort = ''

        if (string) {
            stringShort = string.slice(0, maxLength).trim()
            if (isDots) {
                stringShort += ' ...'
            }
        }

        return stringShort
    } catch (e) {

    }
}